// removed by extract-text-webpack-plugin
module.exports = {"Loading":"Init__Loading__2P1po","SectionTitle":"Init__SectionTitle__1WWl3","Leader":"Init__Leader__2Y_RW","LeaderImage":"Init__LeaderImage__1s4Zk","DummyInvitation":"Init__DummyInvitation__xB6Pb","loading":"Init__loading__1sSeR","InvitationImage":"Init__InvitationImage__3uvKk","Invitation":"Init__Invitation__3LQhw","InvitationURL":"Init__InvitationURL__1O-fh","Users":"Init__Users__PMZHj","User":"Init__User__1QgKT","UserImage":"Init__UserImage__3chUk","Button":"Init__Button__3V7Wj","Forward":"Init__Forward__1BQPb"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Stage/Init/Init.css
// module id = 390
// module chunks = 0